/**
 * @author <Aniket.P>
 * @description MedTransGo constants
 * @copyright Supra International, inc
 */
export class MedTransGoConstants {

    public static readonly FIELD_NAME_TOKEN = 'id_token';
    public static readonly FIELD_STATE = 'state';
    public static readonly FIELD_PROFILE = 'profile';
    public static readonly FIELD_INTERPRETER_PROFILE = 'interpreter_profile';
    public static readonly FIELD_TRANSPORTER_PROFILE = 'transporter_profile';

    public static readonly STATUS_SETUP_PENDING = 'SETUP_PENDING';
    public static readonly PAGINATION_LIMIT = 10;
    public static readonly FIELD_LANGUAGES = 'serviceType';
    public static readonly DB_QUERY_MAX_RESULT = 1000;


    // URLs
    public static readonly URL_REQUESTS = '/requests';
    public static readonly VIEW_REQUESTS_PANEL_NAME = 'RequestPanel';
    public static readonly URL_ACCEPT_REQUEST = ':id/accept';
    public static readonly VIEW_ACCEPT_REQUESTS_NAME = 'AcceptRequest';
    public static readonly VIEW_AUCTION_NAME = 'AuctionModal';
    public static readonly URL_SIGNUP = '/register';
    public static readonly VIEW_SIGNUP_NAME = 'SignupPage';
    public static readonly URL_HOME = '/home';
    public static readonly VIEW_HOME_NAME = 'HomePage';
    public static readonly URL_ACCOUNT_SETUP = '/account-setup';
    public static readonly VIEW_ACCOUNT_SETUP_NAME = 'AccountSetup';
    public static readonly URL_PERSONAL_INFO = 'personal-info';
    public static readonly VIEW_PERSONAL_INFO_NAME = 'PersonalInfo';
    public static readonly URL_HEALTH_INSURANCE_INFO = 'healthInsurance';
    public static readonly VIEW_HEALTH_INSURANCE_INFO_NAME = 'HealthInsuranceInfo';
    public static readonly URL_DRIVER_INFO = 'driver-info';
    public static readonly VIEW_DRIVER_INFO_NAME = 'DriverInfo';
    public static readonly URL_PAYMENT_INFO = 'payment-info';
    public static readonly VIEW_PAYMENT_INFO_NAME = 'PaymentInformation';
    public static readonly URL_UPLOAD_CERTIFICATE = 'upload-certificate';
    public static readonly VIEW_UPLOAD_CERTIFICATE_NAME = 'UploadCertificate';
    public static readonly URL_UPLOAD_DOCUMENTS = 'upload-documents';
    public static readonly VIEW_UPLOAD_DOCUMENTS_NAME = 'UploadDocuments';
    public static readonly URL_TRANSPORTATION_QUESTIONNAIRE = 'questionnaire';
    public static readonly VIEW_TRANSPORTATION_QUESTIONNAIRE_NAME = 'TransportationQuestionnaire';
    public static readonly VIEW_REQUEST_DETAILS_NAME = 'ViewRequestDetail';
    public static readonly URL_REVIEW_PROGRESS = '/review-progress';
    public static readonly VIEW_REVIEW_PROGRESS_NAME = 'ReviewProgressPage';

    public static readonly URL_REJECTED_DOCUMENTS = '/rejected-documents';
    public static readonly VIEW_REJECTED_DOCUMENTS = 'UploadRejectedDocument';

    public static readonly URL_HEALTH_INSURANCE = '/health-insurance';
    public static readonly VIEW_HEALTH_INSURANCE = 'HealthInsurance';

    public static readonly VIEW_CALENDAR_NAME = 'calendar';
    public static readonly URL_CALENDAR = '/calendar';

    public static readonly URL_SETTING = '/settings';
    public static readonly VIEW_SETTING_NAME = 'Setting';

    public static readonly URL_TERMSANDCONDITIONS = '/privacy-policy';
    public static readonly VIEW_TERMSANDCONDITIONS_NAME = 'TermsAndConditions';

    public static readonly URL_PAYOUT = '/payouts';
    public static readonly VIEW_PAYOUT_NAME = 'Payout';

    public static readonly VIEW_ADD_UESR_NAME = 'AddUserModal';
    public static readonly URL_ADD_USER = 'members/add';

    public static readonly VIEW_REQUEST_DETAILS_MODAL_NAME = 'ViewRequestDetailModal';
    public static readonly HTTP_URL_VEHICLE = '/v1/vehicle';

    public static readonly URL_REQUESTS_TABLE = '/service-requests';
    public static readonly VIEW_REQUESTS_TABLE_NAME = 'Requests';
    public static readonly URL_ADD_LOCATION = '/locations/add';
    public static readonly VIEW_ADD_LOCATION_NAME = 'AddLocationModal';
    public static readonly URL_UPDATE_LOCATION = 'locations/update';
    public static readonly VIEW_UPDATE_LOCATION_NAME = 'UpdateLocationModal';
    public static readonly URL_ADD_DRIVER = 'drivers/add';
    public static readonly VIEW_ADD_DRIVER_NAME = 'AddDriverModal';
    public static readonly URL_UPDATE_DRIVER = 'drivers/update';
    public static readonly URL_VIEW_DRIVER = 'drivers/view';
    public static readonly VIEW_UPDATE_DRIVER_NAME = 'UpdateDriverModal';
    public static readonly VIEW_DRIVER_NAME = 'ViewDriverDetailModal';
    public static readonly URL_UPDATE_PROFILE = 'update';
    public static readonly VIEW_UPDATE_PROFILE = 'updateProfile';
    public static readonly URL_UPDATE_TRANSPORTER_DOCUMENT = 'documents/update';
    public static readonly VIEW_UPDATE_TRANSPORTER_DOCUMENT = 'UpdateDocumentModal';
    public static readonly VIEW_UPLOAD_DOCUMENT = 'UploadDocumentsModal';
    public static readonly URL_UPLOAD_DOCUMENT = 'uploadDocuments';

    // HTTP URL
    public static readonly HTTP_URL_LOGIN = '/v1/authentication';
    public static readonly HTTP_URL_PARTNERS = '/v1/partners';
    public static readonly HTTP_URL_INTERPRETERS = '/v1/interpreters';
    public static readonly HTTP_URL_LANGUAGES = '/v1/languages';
    public static readonly HTTP_URL_RESOURCE = '/v1/resources';
    public static readonly HTTP_URL_REQUESTS = '/v1/requests';
    public static readonly HTTP_URL_ROUTES = '/v1/routes';
    public static readonly HTTP_URL_INVOICES = '/v1/invoices';
    public static readonly HTTP_URL_PAYMENT = '/v1/payment';
    public static readonly HTTP_URL_PAYMENT_SOURCE = `${MedTransGoConstants.HTTP_URL_PAYMENT}/source`;
    public static readonly HTTP_URL_CHANGE_PASSWORD = '/v1/changePassword';
    public static readonly HTTP_URL_DEFAULT_PAYMENT_SOURCE = `${MedTransGoConstants.HTTP_URL_PAYMENT}/defaultSource`;
    public static readonly HTTP_URL_VERIFY_PAYMENT_SOURCE = `${MedTransGoConstants.HTTP_URL_PAYMENT}/verifyPaymentSource`;
    public static readonly HTTP_URL_PAYOUTS = '/v1/payouts';
    public static readonly HTTP_URL_USERS = '/v1/users';
    public static readonly HTTP_URL_TRANSPORTERS = '/v1/transporters';

    public static readonly URL_INTERPRETERSID = 'interpreters/:interpreterId';
    public static readonly URL_CERTIFICATEID = 'certificates/:id';
    public static readonly URL_VIEW_CERTITIFICATE = 'interpreters/:interpreterId/certificates/:id';
    public static readonly VIEW_CERTITIFICATE_NAME = 'view-certificate';
    public static readonly HTTP_URL_REQUEST = '/v1/requests';


    // Events
    public static readonly EVENT_SHOW_TOAST = 'show_toast';
    public static readonly EVENT_LOGOUT = 'logout';
    public static readonly EVENT_SAVE_PROFILE_REQUEST = 'save_profile_request';
    public static readonly EVENT_CHANGE = 'change';
    public static readonly EVENT_SHOW_LOADER = 'show_loader';
    public static readonly EVENT_CONFIRMATION_DIALOG = 'confirmationDialog';
    public static readonly EVENT_PAGE_CHANGE = 'pageChange';

    // Error Code
    public static readonly ERROR_CODE_NETWORK_ERROR = 'NETWORK_ERROR';
    public static readonly ERROR_CODE_ROUTE_NOT_FOUND = 'ROUTE_NOT_FOUND';

    // Regular Expression Constants
    public static readonly PHONE_REGX = /^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
    public static readonly PASSWORD_REGX = /^(?=.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).*$/;
}
